import { inject, InjectionToken } from '@angular/core';
import { bytesToMb } from '@simOn/utils/helpers';
import { AssetAttachmentLimitsToken, AttachmentSizeLimitsToken } from '@simOn/utils/tokens';
import { DefaultSupportedDocumentTypes, SupportedDocumentLabels } from './supported-extensions.const';

export const UPLOAD_DOCUMENT_TOKEN = new InjectionToken<{
  uploadDescription: string;
  supportedFormatsDescription: string;
  supportedFormats: SupportedDocumentLabels[];
  maxSize: number;
  maxUpload: number;
}>('Upload document token', {
  factory: () => {
    const maxUpload = inject(AssetAttachmentLimitsToken).docMaxNumber;
    const maxSize = inject(AttachmentSizeLimitsToken).docMaxSize;
    return {
      uploadDescription: $localize`:@@UPLOAD_LABEL_2:Maximum number of files: ${maxUpload}  (${bytesToMb(maxSize)} MB each)`,
      supportedFormatsDescription: 'PDF, DOC, EXCEL, WORD, PPTX, TXT',
      supportedFormats: DefaultSupportedDocumentTypes.map(({ label }) => label),
      maxSize,
      maxUpload
    } as const;
  }
});
